import { useContext, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { BookingThemedRoot } from 'src/modules/booking/components'
import { BookingWrapper } from 'src/modules/booking/containers'
import { LoadingWrapperContext } from 'src/modules/core/context'

import classes from './booking.module.scss'

export const Booking = () => {
  const { disableLoading } = useContext(LoadingWrapperContext)
  const params = useParams()

  useEffect(() => {
    disableLoading()
  }, [disableLoading])

  return (
    <BookingThemedRoot providerId={params.providerId} className={classes.root}>
      <BookingWrapper />
    </BookingThemedRoot>
  )
}
